const info = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Designates that more information is available about the adjoining object.",
    usage: "",
    category: "Alerts and Notifications",
    tags: []
  },
  children: [{
    type: "path",
    props: {
      d: "M11.264 18h1.672V9.492h-1.672V18zm1.922-11.023c0-.586-.461-1.032-1.086-1.032s-1.086.446-1.086 1.032c0 .578.461 1.023 1.086 1.023s1.086-.445 1.086-1.023zM12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0 1.5C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
    }
  }]
};
export default info;